module.exports = __webpack_public_path__ + "media/src/images/favicon-43765288ac2ab7909f44ca6263067929.png";